import { create } from 'zustand';
import { useSessionBundlesStore } from './sessionBundlesStore';

interface PromotionsStoreState {
  hasActivePromotions: boolean;
  loading: boolean;
  checkActivePromotions: () => Promise<void>;
}

export const usePromotionsStore = create<PromotionsStoreState>((set) => ({
  hasActivePromotions: false,
  loading: false,
  checkActivePromotions: async () => {
    set({ loading: true });
    try {
      const sessionBundlesData = await useSessionBundlesStore.getState().fetchSessionBundles();

      if (!sessionBundlesData) {
        set({ hasActivePromotions: false, loading: false });
        return;
      }

      const allItems = sessionBundlesData.sessionBundles || [];

      const now = new Date();
      const hasPromos = allItems.some((item) => {
        if (item.pricingRules && item.pricingRules.length > 0) {
          return item.pricingRules.some((rule: any) => {
            const startValid = !rule.startDate || new Date(rule.startDate) <= now;
            const endValid = !rule.endDate || new Date(rule.endDate) >= now;
            return startValid && endValid && rule.priority >= 100;
          });
        }

        return false;
      });

      set({ hasActivePromotions: hasPromos, loading: false });
    } catch (error) {
      console.error('Failed to check active promotions:', error);
      set({ hasActivePromotions: false, loading: false });
    }
  },
}));
